import React from "react";
import { get } from "../../utils";
import Axios from "axios";
import { saveAs } from 'file-saver';
import { Button, CircularProgress } from "@material-ui/core";

interface DataColumn {
  title: string;
  dataIndex: string;
}

export interface TableBoundary {
  currentHeight: number;
  totalHeight: number;
}

interface DataTableProps {
  title?: string;
  columns: DataColumn[];
  data: any[];
  allData?: any[];
  type?: string;
  onClick?: (row: any, unselect?: boolean) => void;
  onScroll?: (bound: TableBoundary) => void;
}

export const DataTable: React.FC<DataTableProps> = (props) => {
  const { title, columns, data, allData, type, onClick, onScroll } = props;

  const [loading, setLoading] = React.useState<boolean>(false);

  const ref = React.useRef<HTMLTableSectionElement>(null);

  const handleOnScroll = (event: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const { scrollHeight, scrollTop } = event.currentTarget;
    if (onScroll) {
      onScroll({ totalHeight: scrollHeight, currentHeight: scrollTop });
    }
  };

  const handleOnClickDownloadButton = (title: string = 'data', columns: DataColumn[], data: any[]) => {
    setLoading(true);

    const body = {title, columns, data};

    Axios.post(`/excel/download`, body, { responseType: 'blob' })
      .then((res) => {
        const filename = decodeURI(res.headers['content-disposition'].split(' ')[1].replace('filename=', ''));
        saveAs(res.data, filename);
      })
      .catch(err => console.error(err))
      .finally(() => {
        setLoading(false);
      })
  };

  return (
    <div className={type || "portal-datatable-no-overflow"} onScroll={handleOnScroll}>
      <table cellPadding={5} cellSpacing={0}>
      <caption style={{ marginBottom: '5px' }}>
            {title}

            <Button
              variant="contained"
              style={title ? { marginLeft: '10px' } : {}}
              size="small"
              onClick={(evt: any) => handleOnClickDownloadButton(title, columns, (allData ? allData : data))}
              disabled={loading}
            >
              Export
              {
                loading && (
                  <CircularProgress
                    size={24}
                    style={{
                      color: 'green',
                      textAlign: 'center',
                      position: 'absolute'
                    }}
                  />
                )
              }
            </Button>
          </caption>

        <thead>
          <tr>
            {columns.map((item) => (
              <th key={item.title}>{item.title}</th>
            ))}
          </tr>
        </thead>
        <tbody ref={ref}>
          {data.map((row, index) => (
            <tr
              key={index}
              onClick={(evt) => {
                const { classList } = evt.currentTarget;
                if (onClick) {
                  if (classList.contains("selected")) {
                    classList.remove("selected");
                    onClick(row, true);
                  } else {
                    if (ref.current) {
                      ref.current
                        .querySelectorAll("tr.selected")
                        .forEach((row) => row.classList.remove("selected"));
                    }
                    classList.add("selected");
                    onClick(row);
                  }
                }
              }}
            >
              {columns.map((key) => (
                <td key={key.dataIndex}>{get(row, key.dataIndex)}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
